<script lang="ts">
  import { browser } from '$app/environment';
  import type { ReviewPanelProps } from '$lib/types/contentTypes';
  import { REVIEW_VARIANT } from '$lib/constants/constants';
  import ReviewCard from './ReviewCard.svelte';
  import ReviewContent from './ReviewContent.svelte';
  import Carousel from 'svelte-carousel';
  import ArrowButton from '../../control/ArrowButton.svelte';

  export let backgroundVariant: ReviewPanelProps['backgroundVariant'];
  export let reviewsCollectionItems: ReviewPanelProps['reviewsCollection'] = [];
  export let title: ReviewPanelProps['title'];
  export let eyebrowText: ReviewPanelProps['eyebrowText'];

  let carousel: any;
  let variantClass = '';
  const itemCount: number = reviewsCollectionItems?.length || 0;

  $: switch (backgroundVariant) {
    case REVIEW_VARIANT.WHITE:
      variantClass = 'bg-white';
      break;
    case REVIEW_VARIANT.GREY:
      variantClass = 'bg-gray-50 py-8 lg:py-16 ';
      break;
  }

  const handleNextClick = () => {
    carousel.goToNext();
  };
  const handlePrevClick = () => {
    carousel.goToPrev();
  };
</script>

<section class="w-full relative mx-auto {variantClass}">
  {#if browser && itemCount}
    <ReviewCard {title} {eyebrowText} />
    <Carousel
      bind:this={carousel}
      arrows={false}
      dots={false}
      infinite={true}
      particlesToShow={1}
      autoplay={true}
      autoplayDuration={5000}
      pauseOnFocus={true}
    >
      {#if reviewsCollectionItems?.length && itemCount > 1}
        {#each reviewsCollectionItems as review}
          <ReviewContent reviewText={review.reviewText} reviewerName={review.reviewerName} />
        {/each}
      {/if}
    </Carousel>
  {/if}
  {#if itemCount > 1}
    <div class="justify-center items-start gap-8 flex mt-7 sm:mt-12 flex-row w-full">
      <ArrowButton direction="left" on:click={handlePrevClick} />
      <ArrowButton direction="right" on:click={handleNextClick} />
    </div>
  {:else if reviewsCollectionItems?.length}
    {#each reviewsCollectionItems as review}
      <ReviewContent reviewText={review.reviewText} reviewerName={review.reviewerName} />
    {/each}
  {/if}
</section>
